import restapi from 'utils/restapi';
import { addLang } from "utils/addLang";

import { baseErrorsHandlerDecorator } from 'redux/utils';

import {
  FETCH_LOCATION_LINKS_LIST,
  FETCH_LOCATION_LINKS_LIST_ERROR,
  CLEAR_FETCH_LOCATION_LINKS_LIST,
  APPLY_LOCATION_LINK_DRAG,
  APPLY_LOCATION_LINK_DRAG_ERROR,
  CLEAR_LOCATION_LINK_DRAG,
  CREATE_LOCATION_LINK_SUCCESS,
  CREATE_LOCATION_LINK_ERROR,
  CLEAR_CREATE_LOCATION_LINK,
  PATCH_LOCATION_LINK_SUCCESS,
  PATCH_LOCATION_LINK_ERROR,
  CLEAR_PATCH_LOCATION_LINK,
  DELETE_LOCATION_LINK_SUCCESS,
  DELETE_LOCATION_LINK_ERROR,
  CLEAR_DELETE_LOCATION_LINK,
  CREATE_LOCATION_MARKER_SUCCESS,
  CREATE_LOCATION_MARKER_ERROR,
  CLEAR_CREATE_LOCATION_MARKER,
  PATCH_LOCATION_MARKER_SUCCESS,
  PATCH_LOCATION_MARKER_ERROR,
  CLEAR_PATCH_LOCATION_MARKER,
  DELETE_LOCATION_MARKER_SUCCESS,
  DELETE_LOCATION_MARKER_ERROR,
  CLEAR_DELETE_LOCATION_MARKER,
} from 'redux/location-links/types';


export const fetchLocationLinksList = () => baseErrorsHandlerDecorator(
  FETCH_LOCATION_LINKS_LIST,
  FETCH_LOCATION_LINKS_LIST_ERROR,
  () => restapi.get(addLang('links/maps/')),
  false,
);

export const clearFetchLocationLinksList = () => dispatch => {
  dispatch({
    type: CLEAR_FETCH_LOCATION_LINKS_LIST,
  });
};

export const applyLocationLinkDrag = formData => baseErrorsHandlerDecorator(
  APPLY_LOCATION_LINK_DRAG,
  APPLY_LOCATION_LINK_DRAG_ERROR,
  () => restapi.post(addLang('links/maps/ordering/'), formData),
  false,
  true /* actionSucces */,
);

export const clearLocationLinkDrag = () => dispatch => {
  dispatch({
    type: CLEAR_LOCATION_LINK_DRAG,
  });
};

export const createLocationLink = formData => baseErrorsHandlerDecorator(
  CREATE_LOCATION_LINK_SUCCESS,
  CREATE_LOCATION_LINK_ERROR,
  () => restapi.post(addLang('links/maps/'), formData),
  false,
  true /* actionSucces */,
);

export const clearCreateLocationLink = () => dispatch => {
  dispatch({
    type: CLEAR_CREATE_LOCATION_LINK,
  });
};

export const patchLocationLink = (linkId, formData) => baseErrorsHandlerDecorator(
  PATCH_LOCATION_LINK_SUCCESS,
  PATCH_LOCATION_LINK_ERROR,
  () => restapi.patch(addLang(`links/maps/${linkId}/`), formData),
  false,
  true /* actionSucces */,
);

export const clearPatchLocationLink = () => dispatch => {
  dispatch({
    type: CLEAR_PATCH_LOCATION_LINK,
  });
};

export const deleteLocationLink = linkId => baseErrorsHandlerDecorator(
  DELETE_LOCATION_LINK_SUCCESS,
  DELETE_LOCATION_LINK_ERROR,
  () => restapi.delete(addLang(`links/maps/${linkId}/`)),
  false,
  true /* actionSucces */,
);

export const clearDeleteLocationLink = () => dispatch => {
  dispatch({
    type: CLEAR_DELETE_LOCATION_LINK,
  });
};

export const createLocationMarker = formData => baseErrorsHandlerDecorator(
  CREATE_LOCATION_MARKER_SUCCESS,
  CREATE_LOCATION_MARKER_ERROR,
  () => restapi.post(addLang('links/maps/markers/'), formData),
  false,
  true /* actionSucces */,
);

export const clearCreateLocationMarker = () => dispatch => {
  dispatch({
    type: CLEAR_CREATE_LOCATION_MARKER,
  });
};

export const patchLocationMarker = (markerId, formData) => baseErrorsHandlerDecorator(
  PATCH_LOCATION_MARKER_SUCCESS,
  PATCH_LOCATION_MARKER_ERROR,
  () => restapi.patch(addLang(`links/maps/markers/${markerId}/`), formData),
  false,
  true /* actionSucces */,
);

export const clearPatchLocationMarker = () => dispatch => {
  dispatch({
    type: CLEAR_PATCH_LOCATION_MARKER,
  });
};

export const deleteLocationMarker = markerId => baseErrorsHandlerDecorator(
  DELETE_LOCATION_MARKER_SUCCESS,
  DELETE_LOCATION_MARKER_ERROR,
  () => restapi.delete(addLang(`links/maps/markers/${markerId}/`)),
  false,
  true /* actionSucces */,
);

export const clearDeleteLocationMarker = () => dispatch => {
  dispatch({
    type: CLEAR_DELETE_LOCATION_MARKER,
  });
};
